import { getRequest } from 'lib/api-proxy-client';
import { SeedError } from 'lib/errors';
import type { Bookmark } from 'entities/bookmark';

export const bookmarkEndpoint = (productGroup: string): string =>
  `/experience/bookmark/${productGroup}/`;

export async function apiBookmarkGet(
  productGroup: string,
): Promise<Bookmark | null> {
  try {
    return await (await getRequest(bookmarkEndpoint(productGroup))).json();
  } catch (error) {
    if (error instanceof SeedError && error.errorCode === 'NOT_FOUND') {
      return null;
    }
    throw error;
  }
}
